import React, { useState } from 'react';
import { NotificationManager } from "react-notifications";
import changePasswordResponse from '../../apis/password/changePassword';
import { validatePassword, validatePasswordMatch, passwordValidationMsg, passwordMismatchMsg } from '../../utilities/validations';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import '../resetpassword/resetpassword.css';

const PasswordChangeRequired = ({ userId, oldPassword, onPasswordChanged }) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [newPasswordTouched, setNewPasswordTouched] = useState(false);
  const [confirmPasswordTouched, setConfirmPasswordTouched] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const isNewPasswordValid = validatePassword(newPassword) && newPassword.length > 0;
  const isConfirmPasswordValid = validatePasswordMatch(newPassword, confirmPassword) && confirmPassword.length > 0;
  const shouldDisableNewPassword = isConfirmPasswordValid;

  const handleNewPasswordChange = (value) => {
    setNewPassword(value);
    if (value) {
      setNewPasswordTouched(true);
    }
  };

  const handleConfirmPasswordChange = (value) => {
    setConfirmPassword(value);
    if (value) {
      setConfirmPasswordTouched(true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const payloadData = {
      userid: userId,
      password: oldPassword,
      newpassword: newPassword
    };
    
    try {
      const changePasswordReqData = await changePasswordResponse(payloadData);
      
      if (changePasswordReqData.data.message.includes('Congrats! you have sucessfully Updated password.')) {
        NotificationManager.success("Password Updated Successfully", "Success", 10000);
        
        if (onPasswordChanged) {
          onPasswordChanged();
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="login_wrapper_main">
        <div className='login_container login-box-border reset-password-modern'>
          <div className='candidate-signin-title'>
            <p className='fs-semi-bold fs-22'>Change your password</p>
            <p className='reset-subtitle'>You need to change your password to continue</p>
          </div>
          
          <div className='reset-password-content'>
            <div className='form-group-reset'>
              <label className="field_name_reset" htmlFor="rrNewPwd">
                New Password
              </label>
              <div className="password-input-wrapper">
                <input
                  type={showNewPassword ? "text" : "password"}
                  id="rrNewPwd"
                  name="rrNewPwd"
                  className='password-input-reset password-input-no-reveal'
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => handleNewPasswordChange(e.target.value)}
                  disabled={shouldDisableNewPassword}
                  required
                />
                <button
                  type="button"
                  className="password-eye-btn"
                  onClick={() => setShowNewPassword((prev) => !prev)}
                  aria-label={showNewPassword ? "Hide password" : "Show password"}
                >
                  {showNewPassword ? (
                    <VisibilityOffIcon />
                  ) : (
                    <VisibilityIcon />
                  )}
                </button>
              </div>
              <p className='password-hint'>{passwordValidationMsg}</p>
              
              {newPasswordTouched && !isNewPasswordValid && newPassword && (
                <p className='form-error-reset'>{passwordValidationMsg}</p>
              )}
            </div>
            
            <div className="form-group-reset mt_20">
              <label className="field_name_reset" htmlFor="rrConfirmPwd">
                Confirm Password
              </label>
              <div className="password-input-wrapper">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  id="rrConfirmPwd"
                  name="rrConfirmPwd"
                  className='password-input-reset password-input-no-reveal'
                  placeholder="Re-enter new password"
                  value={confirmPassword}
                  onChange={(e) => handleConfirmPasswordChange(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="password-eye-btn"
                  onClick={() => setShowConfirmPassword((prev) => !prev)}
                  aria-label={showConfirmPassword ? "Hide password" : "Show password"}
                >
                  {showConfirmPassword ? (
                    <VisibilityOffIcon />
                  ) : (
                    <VisibilityIcon />
                  )}
                </button>
              </div>
              
              {confirmPasswordTouched && !isConfirmPasswordValid && confirmPassword && (
                <p className='form-error-reset'>{passwordMismatchMsg}</p>
              )}
            </div>
            
            <div className='reset-password-btn-container'>
              <button
                type="submit"
                className='btn-reset-password-modern'
                disabled={!isNewPasswordValid || !isConfirmPasswordValid}
              >
                Change Password
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default PasswordChangeRequired;
